/* eslint-disable prettier/prettier */
import React from 'react';
import _ from 'lodash';
import PlayersTableRow from './PlayersTableRow';
import { playerStatsOptions } from './MatchPlayerStatsFilter';
import { addRankingNumberWithDuplicates } from '../../utils/functionalUtils';

function PlayersTable({
  playersStats,
  playersStatsLoading,
  playerLimit,
  setPlayerLimit,
  orderBy,
  orderDirection,
  team,
  nationality,
  selectedStat,
}) {
  if (playersStatsLoading) {
    return (
      <div className="stats-table__row">
        <div className="col-12 text-center stats-font-larger">Laddar...</div>
      </div>
    );
  }

  const sortedPlayersWithRanking = addRankingNumberWithDuplicates(
    _.orderBy(
      playersStats?.filter(
        (player) =>
          player[orderBy] > 0 &&
          player.displayName !== 'undefined undefined' &&
          (team === '' || player.teamAbbrv === team) &&
          (nationality === 'Alla nationaliteter' ||
            player.nationality === nationality)
      ),
      orderBy,
      orderDirection
    ),
    orderBy
  );

  const filteredRows =
    playerLimit === 0
      ? sortedPlayersWithRanking
      : sortedPlayersWithRanking.slice(0, playerLimit);

  if (filteredRows.length > 0) {
    return (
      <>
        {filteredRows?.map((player, i) => (
          <PlayersTableRow
            player={player}
            i={i + 1}
            stats={playerStatsOptions}
            selectedStat={selectedStat}
          />
        ))}
        {playerLimit > 0 && sortedPlayersWithRanking.length > playerLimit && (
          <div style={{ padding: '10px' }}>
            <button
              type="button"
              onClick={() => setPlayerLimit(0)}
              className="button button--primary load-more-players"
            >
              SE MER
            </button>
          </div>
        )}
      </>
    );
  }

  return (
    <div className="stats-table__row">
      <div className="col-12 text-center stats-font-larger">
        Statistik för löpdistans och maxhastighet saknas för denna match.
      </div>
    </div>
  );
}
export default PlayersTable;
